<template>
  <div class="tree-item-handle">⋮⋮</div>
</template>

<style scoped>
.tree-item-handle {
  cursor: grab;
  user-select: none;
  letter-spacing: -0.5px;
  opacity: 0.5;
}
</style>
